import React from 'react';
import ReduceCreditUsageWithLimitIncreaseView from 'partial/OfferManager/modules/ReduceCreditUsageWithLimitIncrease/ReduceCreditUsageWithLimitIncreaseView';
import {
  CLICK,
  buildAttributes,
} from 'partial/OfferManager/modules/staticModule';
import { withConfig } from 'hoc/config.hoc.js';
import { useLinkHandler } from 'hook/event.hook';
import { useSeenModulePixel, useViewModule } from 'hook/helper.hook';
import { getViewModuleTrackingAttributes } from 'helpers/tracking.helpers';
import { CREDIT_USAGE_ACTION } from 'types/morph.pagePosition.constants';
import GoalReduceCreditUsageWithLimitIncreaseController from './experiments/GoalReduceCreditUsageWithLimitIncrease/GoalReduceCreditUsageWithLimitIncreaseController';

function ReduceCreditUsageWithLimitIncreaseController(props) {
  const creditLimit =
    props?.creditInfo?.creditScoreAnalysis?.creditUsage?.limit;
  const debt = props?.creditInfo?.creditScoreAnalysis?.creditUsage?.debt;
  const creditUsage = Math.round((debt / creditLimit) * 100);
  let potentialLimit = 0;

  if (props?.offers?.length > 0) {
    potentialLimit = props?.offers?.[0]['predictedCreditLimit'] + creditLimit;
  }
  const potentialCreditUsage = Math.round((debt / potentialLimit) * 100);
  const { config } = props;
  const finalConfig = config
    ? config
    : { disclaimers: { potentialScoreChangeToolTip: {} } };
  const { disclaimers } = finalConfig;
  const { potentialScoreChangeToolTip } = disclaimers;
  const onLinkClickCallback = useLinkHandler(props?.eventHandler);

  const onClickApply = () => {
    props.eventHandler(
      CLICK,
      buildAttributes(props, {
        'Click Type': 'Apply',
      }),
    );
  };
  const atr = getViewModuleTrackingAttributes(
    CREDIT_USAGE_ACTION,
    props?.modulePosition,
  );

  useViewModule(atr);

  const seenPixel = useSeenModulePixel(atr);

  if (props?.lowerCreditUsageShowModule) {
    return <GoalReduceCreditUsageWithLimitIncreaseController {...props} />;
  } else {
    return (
      <ReduceCreditUsageWithLimitIncreaseView
        onClickApply={onClickApply}
        creditUsage={creditUsage}
        creditLimit={creditLimit}
        potentialCreditUsage={potentialCreditUsage}
        potentialLimit={potentialLimit}
        potentialScoreChangeToolTip={potentialScoreChangeToolTip}
        onLinkClickCallback={onLinkClickCallback}
        seenPixel={seenPixel}
        {...props}
      />
    );
  }
}

const connectedReduceCUController = withConfig(
  ReduceCreditUsageWithLimitIncreaseController,
);

export { connectedReduceCUController as ReduceCreditUsageWithLimitIncreaseController };
